import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteTrip = () => {
	const queryClient = useQueryClient()

	return useMutation<void, Error, { tripId: string }>({
		mutationFn: async ({ tripId }) => {
			await api.delete(`/trips/${tripId}`)
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['trips'] })
			if (variables?.tripId) {
				queryClient.removeQueries({ queryKey: ['trip', variables.tripId] })
			}
		},
	})
}

export default useDeleteTrip
